<template>
  <div class="match football mini" ref="matchroot" :class="[match.info.status]">

    <div class="list-title">
      <router-link
        class="clean"
        :to="{name:'match', params:{key:match.info.key}}">
        {{match.info.home.name}} - {{match.info.away.name}}</router-link>
        <span class="live-tag" v-if="match.info.status.isStarted">Live</span>
    </div>

    <div v-if="match.info.status.isCompleted">
      <span class="highlight">{{match.result.title}}</span> <span> (FT)</span>
    </div>
    <div v-else-if="match.info.status.isStarted">
      <div v-if="match.result && match.result.title" class="highlight">
        {{match.result.title}}
        <span v-if="minuteLabel.length" class="changing"> {{minuteLabel}}</span>
      </div>
    </div>
    <div>
      <span v-if="showDate">{{match.info.start_at | relativeShortDate}} </span>
      <span class="info">{{match.info.start_at | relativeTime}}</span>
    </div>

    <div><span class="sport-tag" v-if="showSport">F</span><router-link class="clean" :to="{name:'tournament', params: {key: match.info.tournament.key}}">{{match.info.tournament.name}}</router-link></div>
  </div>
</template>
<style lang="scss" scoped>
</style>

<script>
import { FootballPush } from '@/models/push'

export default {
  props: {
    match: Object,
    showDate: {
      type: Boolean,
      default: true
    },
    forDate: {
      type: Object,
      default: null
    },
    showSport: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      minuteLabel: '',
      pushId: null,
      pushInited: false
    }
  },
  mounted () {
    if (this.match.requiresLiveUpdate && (!this.pushInited)) {
      this.match.updateLatest(true).then(() => {
        this.minuteLabel = this.match.minuteLabel
      })
      this.pushId = FootballPush.instance().listenMatch(this.match.info.key, (updatedMatch) => {
        this.match.overwrite(updatedMatch)
        this.onMatchUpdated(this.match)
      }, () => {
        this.minuteLabel = this.match.minuteLabel
      })
      this.pushInited = true
    }
  },
  destroyed () {
    FootballPush.instance().stopMatchUpdate(this.matchKey, this.pushId)
  },
  methods: {
    onMatchUpdated (match) {
      // this.match = match
    }
  }
}
</script>
